import { FilterParams } from '@synergy/models';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { AttributeCounts } from '../../../models/attribute-counts';
import { FilterChip } from '../../../components/filter';
import { initialArticleSearchResultsSelector } from '../../../store/articles-selectors';
import { useAppSelector } from '../../../../store/store';

export const AttributeFilterChips = (): ReactElement | null => {
    const [searchParams, setSearchParams] = useSearchParams();
    const attributeKeys = searchParams.get(FilterParams.AttributeKeys);
    const { attributesFromSearch } = useAppSelector(initialArticleSearchResultsSelector);

    if (!attributeKeys) return null;

    const keys = attributeKeys.split(',');
    const attributesFromSearchValues = Object.values(attributesFromSearch ?? {});

    const attributes: AttributeCounts[] = [];
    for (const key of keys) {
        for (const attributeArray of attributesFromSearchValues) {
            const attribute = attributeArray.find(a => a.key === key);
            if (attribute) {
                attributes.push(attribute);
                break;
            }
        }
    }

    const handleChipDelete = (attribute: AttributeCounts): void => {
        let attr = searchParams.get(FilterParams.AttributeKeys)?.split(',');
        if (attr?.some(a => a === attribute.key)) {
            attr = attr.filter(a => a !== attribute.key);
            if (attr.length === 0) {
                searchParams.delete(FilterParams.AttributeKeys);
            } else {
                searchParams.set(FilterParams.AttributeKeys, attr.join(','));
            }
        } else {
            searchParams.set(FilterParams.AttributeKeys, [...(attr ?? []), attribute.key].join(','));
        }
        setSearchParams(searchParams);
    };

    return (
        <>
            {attributes.map(a => {
                return (
                    <FilterChip
                        key={a.key}
                        label={
                            <Stack direction="row" gap={0.5}>
                                <strong>{a.name}</strong>
                                <span>{a.value}</span>
                            </Stack>
                        }
                        onChipDelete={() => handleChipDelete(a)}
                    />
                );
            })}
        </>
    );
};
